// extracted by mini-css-extract-plugin
export default {"toggle":"ToggleSound_toggle__patAK","hasMoved":"ToggleSound_hasMoved__sqMXi","hasClicked":"ToggleSound_hasClicked__KbvDU","isHoveringTerms":"ToggleSound_isHoveringTerms__+OByi"};